import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import axios from 'axios'

Vue.use(Router)

let router = new Router({
    mode: 'history',

    routes: [{
            name: 'login',
            path: '/auth/login',
            component: () =>
                import ('@/components/Auth/appLogin'),
        },
        {
            name: '404',
            path: '*',
            component: () =>
                import ('@/components/commonComponents/404'),
        },
        {
            // path: '/',
            path: '/dashboard/basic-dashboard',
            component: () =>
                import ('@/layouts/Layout'),
            meta: {
                requireAuth: true,
            },
            children: [
                // Components

                {
                    name: 'Alerts',
                    path: 'pages/alerts',
                    component: () =>
                        import ('@/views/pages/Alerts'),
                },

                {

                    path: '/profile',
                    meta: {
                        label: 'profile',
                        requiresAuth: true,

                    },
                    component: () =>
                        import ('@/layouts/profileLayout'),
                    children: [{
                            path: '',
                            name: 'Profile',
                            meta: {
                                label: 'profile',
                                requiresAuth: true,

                            },
                            component: () =>
                                import ('@/components/Profile/profile'),
                        },
                        {

                            name: 'changePassword',
                            path: '/changePassword',
                            component: () =>
                                import ('@/components/Profile/changePassword'),

                        },
                    ]
                },

                {
                    name: 'HomeSlider',
                    path: '/homeSlider',
                    component: () =>
                        import ('@/components/Home/HomeSlider/homeSlider'),
                    meta: {
                        requireAuth: true,
                    },
                },
                {
                    name: 'StatisticCount',
                    path: '/statisticCount',
                    component: () =>
                        import ('@/components/Home/StatisticCount/statisticCount'),
                },
                {
                    name: 'BusinessSectors',
                    path: '/businessSectors',
                    component: () =>
                        import ('@/components/Home/BusinessSectors/businessSectors'),
                },
                {
                    name: 'aboutSlider',
                    path: '/aboutSlider',
                    component: () =>
                        import ('@/components/About/AboutSlider/aboutSlider'),
                },
                {
                    name: 'serviceSlider',
                    path: '/serviceSlider',
                    component: () =>
                        import ('@/components/Services/serviceSlider'),
                },
                {
                    name: 'aboutCompany',
                    path: '/aboutCompany',
                    component: () =>
                        import ('@/components/Home/AboutCompany/aboutCompany'),
                },
                {
                    name: 'logo',
                    path: '/logo',
                    component: () =>
                        import ('@/components/Home/Logo/logo'),
                },
                {
                    name: 'serviceProvided',
                    path: '/serviceProvided',
                    component: () =>
                        import ('@/components/Home/ServiceProvided/serviceProvided'),
                },
                {
                    name: 'project',
                    path: '/project',
                    component: () =>
                        import ('@/components/Projects/project'),
                },
                {
                    name: 'contacts',
                    path: '/contacts',
                    component: () =>
                        import ('@/components/Contact/contacts'),
                },
                {
                    name: 'contactView',
                    path: '/contactView/:contactid',
                    props: true,
                    component: () =>
                        import ('@/components/Contact/contactView'),
                },
                {
                    name: 'contactUs',
                    path: '/contactUs',
                    component: () =>
                        import ('@/components/Contact/contactUs'),
                },
                {
                    name: 'complaints',
                    path: '/complaints',
                    component: () =>
                        import ('@/components/Complaints/complaints'),
                },
                {
                    name: 'complaintView',
                    path: '/complaintView/:cid',
                    props: true,
                    component: () =>
                        import ('@/components/Complaints/complaintView'),
                },
                {
                    name: 'VisionMission',
                    path: '/visionMission',
                    component: () =>
                        import ('@/components/About/VisionMission/visionMission'),
                },
                {
                    name: 'Services',
                    path: '/services',
                    component: () =>
                        import ('@/components/Services/services'),
                },
                {
                    name: 'follow',
                    path: '/follow',
                    component: () =>
                        import ('@/components/Follow/follow'),
                },



                {
                    name: 'Icons',
                    path: 'pages/icons',
                    component: () =>
                        import ('@/views/pages/Icons'),
                },

                {
                    name: 'TableSimple',
                    path: 'pages/tables-simple',
                    component: () =>
                        import ('@/views/pages/Icons'),
                },

                {
                    name: 'Dashboard',
                    path: 'dashboard/basic-dashboard',
                    component: () =>
                        import ('@/views/dashboard/BasicDashboard'),
                },



            ]
        },


    ],
})
router.beforeEach((to, from, next) => {

    window.scrollTo({ bottom: 0, left: 0, behavior: 'smooth' });
    if (to.matched.some(route => route.meta.requireAuth && store.state.isLoggedIn == false)) {

        next({
                path: '/auth/login'
            })
            // .catch((err) => {console.log(err)})
        return
    }

    next()
    if (to.matched.some(route => route.name && store.state.isLoggedIn)) {
        axios({
                method: 'POST',
                url: '/authenticate',
                headers: {
                    'token': localStorage.getItem('token')
                }
            }).then(response => {
                if (!response.data.status) {
                    store.commit("sessionOut", true)
                    return
                }
            })
            .catch(err => {
                var msg = err;
                console.log(msg)
            });
    }
    if (to.path === '/auth/login' && store.state.isLoggedIn) {
        next({ name: 'HomeSlider' })
        return
    }
    if (to.path === '/' && store.state.isLoggedIn) {
        next({ name: 'HomeSlider' })
        return
    }
    if (to.path === '/' && !store.state.isLoggedIn) {
        next({ name: 'login' })
        return
    }
});
export default router